package br.com.logicalside.proposes.components.sections

import Res
import androidx.compose.runtime.Composable
import br.com.logicalside.proposes.BodyTextStyle
import br.com.logicalside.proposes.Headline1TextStyle
import br.com.logicalside.proposes.components.layouts.InnerContainer
import br.com.logicalside.proposes.toSitePalette
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Br

@Composable
fun HeroSection() {
    Box(HeroContainerStyle.toModifier().id("hero")) {
        InnerContainer(HeroOverlayStyle.toModifier()) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                SpanText(
                    Res.string.hero_title,
                    Headline1TextStyle.toModifier().then(HeroTitleStyle.toModifier())
                )
                Br()
                SpanText(
                    Res.string.hero_description,
                    BodyTextStyle.toModifier().then(HeroDescriptionStyle.toModifier())
                )
            }
        }
    }
}

val HeroContainerStyle = CssStyle.base {
    Modifier
        .backgroundImage(url("banner.jpg"))
        .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
}

val HeroOverlayStyle = CssStyle.base {
    Modifier
        .fillMaxSize()
        .backgroundColor(colorMode.toSitePalette().neutral.n100.toRgb().copyf(alpha = 0.5f))
        .padding(topBottom = 8.cssRem, leftRight = 2.cssRem)
}

val HeroTitleStyle = CssStyle.base {
    Modifier
        .fontWeight(FontWeight.ExtraBold)
        .textAlign(TextAlign.Center)
        .color(Color.white)
}

val HeroDescriptionStyle = CssStyle.base {
    Modifier
        .textAlign(TextAlign.Center)
        .color(Color.white)
}
